import { NativeModules, Platform, Appearance } from "react-native";
var { One } = NativeModules;
function Material3DynamicColor(name) {
  if (Platform.OS !== "android" || !One) return null;
  var scheme = Appearance.getColorScheme();
  return One.Material3DynamicColor(name, scheme !== null && scheme !== void 0 ? scheme : "unspecified");
}
function Material3Color(name) {
  if (Platform.OS !== "android" || !One) return null;
  var scheme = Appearance.getColorScheme();
  return One.Material3Color(name, scheme !== null && scheme !== void 0 ? scheme : "unspecified");
}
export {
  Material3Color,
  Material3DynamicColor
};
//# sourceMappingURL=materialColor.native.js.map
